import React, { useEffect, useMemo, useReducer, useState } from "react"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import AddNewPOS from "./AddNewPOS"
import Table from "../../Shared/Table"
import SearchHeader from "../../Shared/SearchHeader"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import MasterList from "../../Shared/MasterList"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import usePagination from "../../../../customhooks/usePagination"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const POS = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const [isOpenPOS, setisOpenPOS] = useState(false)
    const [POSData, setPOSData] = useState([]);
    const [POSCode, setPOSCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const [isOpenMasterList, setisOpenMasterList] = useState(false)
        let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'POS')?.IsAdd
    
    // const [rows, setRows] = useState([]); 
    const [show, setShow] = useState(false);
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: true
        // set true if want to display cards as well
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////

    const LoadData = (param, types) => {
        setIsLoading(true)
        // setPOSData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.POS,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setPOSData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setisOpenPOS(true)
                }
            }
        }).catch((error) => {
            setPOSData([])
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (POSData?.length == 0 && isNull(searchParamType)) {
                    setisOpenPOS(true)
                }
            }
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }

    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    const AddPOS = (ID) => {
        setisOpenPOS(true)
        setPOSCode(ID)
    }
    const ClosePOS = () => {
        setisOpenPOS(false)
    }
    const DeletePOS = () => {
        setisOpenPOS(false)
        setIsClose((Math.random()));
    }
    const handleRowSelection = (row) => {
        // console.log(row);
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    // const rows = useMemo(() => {
    //     const totalRow = {
    //         id: 'total',
    //         POSCode: '',
    //         Description: '',
    //     };

    //     return [...POSData, totalRow];
    // }, [POSData]);
    const totalCount = POSData.length - 1;
    const bottomSummaryRows = useMemo(() => {
        // Create a static summary row
        return [
            {
                key: 'totalRow',
                renderCell: () => <strong>Total {totalCount}</strong>,
                resizable: true,
            }
        ];
    }, [totalCount]);
    const columns = [
        {
            key: 'POSCode',
            width: 100,
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'POS Code'} sortIcon={true} type={'number'} colKey={'POSCode'} data={POSData} setData={setPOSData} />),

            renderCell: ({ row }) => {
                // if (row.id === 'total') { 
                //     return <strong>Total {totalCount}</strong>; 
                // }
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddPOS(row.POSCodeID)}>{row.POSCode} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.POSCodeID, row.POSCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.POSCodeID}-${row.POSCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                ); // Regular renderCell for other rows
            }
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={POSData} setData={setPOSData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message" title={row.Description}>
                                {row.Description}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.POSCodeID, row.Description)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.POSCodeID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'FullDescription',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Full Description'} sortIcon={true} type={'string'} colKey={'FullDescription'} data={POSData} setData={setPOSData} />),
            resizable: true,
            width: 650,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.FullDescription}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.POSCodeID, row.FullDescription)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.POSCodeID}-${row.FullDescription}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={POSData} setData={setPOSData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={POSData} setData={setPOSData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },
    ]

    let PopupScreen = "";
    if (isOpenPOS) {
        PopupScreen = <AddNewPOS isOpenPOS={isOpenPOS} onClose={ClosePOS} onDeletePOS={DeletePOS} POSCode={POSCode} type={type} />
    }
    const CloseMasterList = (ID) => {
        setisOpenMasterList(false)
        // setPOSCode(ID) 
    }
    let PopupScreenMasterList = "";
    if (isOpenMasterList) {
        PopupScreenMasterList = <MasterList isOpen={isOpenMasterList} onClose={CloseMasterList} LoadData={LoadData} GridTableName={'MasterListPOS'} SaveTableName={'MASTERLISTPOS'} type={type} Name={"POS"} IsEditAllowed={IsEditAllowed} />
    }
    console.log(PopupScreenMasterList);
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleMasterList = () => {
        setisOpenMasterList(true)
    };
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const POSBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>


                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by POS Code or Description…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddPOS}
                                Excel={handleExcel}
                                masterListButton={handleMasterList}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                showRecentRecordButton={false}
                                searchButton={searchButton}
                                Key={631}
                                Name={'POS'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show === false ?
                    <Table
                        columns={columns}
                        rows={POSData}
                        // bottomSummaryRows={ bottomSummaryRows }
                        // height='500px'
                        rowClass={rowClass}
                        rowKeyGetter={(row) => row.POSCodeID}
                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={631}
                        Name={'POS'}
                        isLoading={isLoading}
                        TableName={'POS'}
                        handleSelectData={handleSelectData}
                        LoadData={() => LoadData(searchParam)}
                        ClearSearch={handleClearSearch}
                    /> : null

                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(POSData?.length == 0 && isNull(searchParamType)){
    //             setisOpenPOS(true)
    //         }       
    //     }
    // },[POSData, searchParamType])
    return (
        <React.Fragment>
            {/* {PopupScreen} */}
            {/* {PopupScreenMasterList} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {POSData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenPOS ? <>{PopupScreen}</> : isOpenMasterList ? <>{PopupScreenMasterList}</> : <>{POSBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenMasterList}
                    {POSBody()}
                </>
            }


        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(POS)